export default __webpack_public_path__ + "static/SR USA - Quality Notice - Statement-5794c372610e8f617b99e6523d675de7.pdf";